import { render, staticRenderFns } from "./html/ProductGallery.html?vue&type=template&id=d1e24158&lang=html&external"
import script from "./js/ProductGallery.js?vue&type=script&lang=js&external"
export * from "./js/ProductGallery.js?vue&type=script&lang=js&external"
import style0 from "./scss/ProductGallery.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports